export default {
  zh: {
    gold: "金币",
    ruby: "红宝石",
    gRc: "金币记录",
    rRc: "红宝石记录",
    enterId: "请输入要划拨的用户id",
    useG: "可用的金币数量",
    useR: "可用的红宝石数量",
    enterG: "请输入要划拨的金币数量",
    enterR: "请输入要划拨的宝石数量",
    appropriateG: "划拨金币",
    appropriateR: "划拨红宝石",
    send: "发送者",
    rec: "接收者",
    time: "时间",
    more: "更多",
    noNation: "只能给你国家的用户进行充值，如果用户不在你的国家，请联系管理员添加",
    opSuc: "操作成功",
    noSearch: "查询不到该用户",
    isSend: (txt) => {
      return `确定给该用户赠送${txt}吗`
    },
    yes: "确定",
    no: "取消",
    noUid: "uid不能为空!!"
  },
  en: {
    gold: "Gold",
    ruby: "Ruby",
    gRc: "Gold Record",
    rRc: "Ruby Record",
    enterId: "Please enter the user id to distribute",
    useG: "Number of gold available",
    useR: "Number of rubies available",
    enterG: "Please enter the quantity of gold to be distributed",
    enterR: "Please enter the number of rubies to distribute",
    appropriateG: "Distribute gold",
    appropriateR: "Distribute Ruby",
    send: "Sender ",
    rec: "Recipient",
    time: "Time",
    more: "More",
    noNation: "You can only recharge users in your country. If the user is not in your country, please contact the administrator to add",
    opSuc: "Operation succeeded",
    noSearch: "The user cannot be found",
    isSend: (txt) => {
      return `Are you sure to give ${txt} gold coins to this user as a gift`
    },
    yes: "confirm",
    no: "cancel",
    noUid: "uid could not be empty!!"
  },
  ar: {
    gold: "ذهب",
    ruby: "ياقوت",
    gRc: "سجل  عملة الذهب",
    rRc: "سجلات ياقوت",
    enterId: "الرجاء إدخال الايدي  المستخدم ليتم تعيينه",
    useG: "كمية الذهب المتاحة",
    useR: "عدد الياقوت المتاحة",
    enterG: "الرجاء إدخال كمية من الذهب الموزع",
    enterR: "الرجاء إدخال عدد الياقوت الذي تم توزيعه",
    appropriateG: "توزيع الذهب",
    appropriateR: "توزيع الياقوت",
    send: "المرسل",
    rec: "الاستقبال",
    time: "الوقت",
    more: "أكثر",
    noNation: "يمكن للمستخدمين فقط في بلدك إعادة الشحن. إذا لم يكن المستخدم في بلدك، فيرجى الاتصال بالمسؤول لإضافة",
    opSuc: "عملية ناجحة",
    noSearch: "لا يمكن العثور على المستخدم",
    isSend: (txt) => {
      return `هل أنت متأكد من الهدية ${txt} لهذا المستخدم`
    },
    yes: "أكد",
    no: "إلغاء",
    noUid: "لا يمكن أن تكون فارغة!!"
  },
  pt:{
    "gold": "Ouro",
    "ruby": "Rubi",
    "gRc": "Registro de Ouro",
    "rRc": "Registro de Rubi",
    "enterId": "Por favor, insira o ID do usuário para distribuir",
    "useG": "Número de ouros disponíveis",
    "useR": "Número de rubis disponíveis",
    "enterG": "Por favor, insira a quantidade de ouro a ser distribuída",
    "enterR": "Por favor, insira a quantidade de rubis a distribuir",
    "appropriateG": "Distribuir ouro",
    "appropriateR": "Distribuir rubi",
    "send": "Remetente",
    "rec": "Destinatário",
    "time": "Tempo",
    "more": "Mais",
    "noNation": "Você só pode recarregar usuários do seu país. Se o usuário não estiver no seu país, entre em contato com o administrador para adicionar",
    "opSuc": "Operação bem-sucedida",
    "noSearch": "O usuário não pode ser encontrado",
    "isSend": (txt) => {
      return `Tem certeza de que deseja dar ${txt} moedas de ouro a este usuário como presente?`
    },
    "yes": "confirmar",
    "no": "cancelar",
    "noUid": "O UID não pode estar vazio!!"
},
  id:{
    "gold": "Emas",
    "ruby": "Ruby",
    "gRc": "Catatan Emas",
    "rRc": "Catatan Ruby",
    "enterId": "Silakan masukkan ID pengguna untuk didistribusikan",
    "useG": "Jumlah emas yang tersedia",
    "useR": "Jumlah ruby yang tersedia",
    "enterG": "Silakan masukkan jumlah emas yang akan didistribusikan",
    "enterR": "Silakan masukkan jumlah ruby yang akan didistribusikan",
    "appropriateG": "Distribusikan emas",
    "appropriateR": "Distribusikan ruby",
    "send": "Pengirim",
    "rec": "Penerima",
    "time": "Waktu",
    "more": "Lebih banyak",
    "noNation": "Anda hanya dapat mengisi ulang pengguna di negara Anda. Jika pengguna tidak berada di negara Anda, silakan hubungi administrator untuk menambahkannya",
    "opSuc": "Operasi berhasil",
    "noSearch": "Pengguna tidak dapat ditemukan",
    "isSend": (txt) => {
      return `Apakah Anda yakin ingin memberikan ${txt} koin emas kepada pengguna ini sebagai hadiah?`
    },
    "yes": "konfirmasi",
    "no": "batal",
    "noUid": "UID tidak boleh kosong!!"
},
  uz:{
    "gold": "Oltin",
    "ruby": "Ruby",
    "gRc": "Oltin yozuvi",
    "rRc": "Ruby yozuvi",
    "enterId": "Foydalanuvchi ID sini kiriting",
    "useG": "Mavjud oltin miqdori",
    "useR": "Mavjud ruby miqdori",
    "enterG": "Taqsimlanadigan oltin miqdorini kiriting",
    "enterR": "Taqsimlanadigan ruby miqdorini kiriting",
    "appropriateG": "Oltinni taqsimlash",
    "appropriateR": "Rubyni taqsimlash",
    "send": "Yuboruvchi",
    "rec": "Qabul qiluvchi",
    "time": "Vaqt",
    "more": "Ko'proq",
    "noNation": "Siz faqat o'z mamlakatingizdagi foydalanuvchilarga to'lov qilishingiz mumkin. Agar foydalanuvchi sizning mamlakatingizda bo'lmasa, administrator bilan bog'laning",
    "opSuc": "Amaliyot muvaffaqiyatli bajarildi",
    "noSearch": "Foydalanuvchi topilmadi",
    "isSend": (txt) => {
      return `Siz haqiqatan ham ushbu foydalanuvchiga ${txt} oltin tanga berishni xohlaysizmi?`
    },
    "yes": "tasdiqlash",
    "no": "bekor qilish",
    "noUid": "UID bo'sh bo'lishi mumkin emas!!"
},
  ru:{
    "gold": "Золото",
    "ruby": "Рубин",
    "gRc": "Запись золота",
    "rRc": "Запись рубинов",
    "enterId": "Пожалуйста, введите ID пользователя для распределения",
    "useG": "Доступное количество золота",
    "useR": "Доступное количество рубинов",
    "enterG": "Введите количество золота для распределения",
    "enterR": "Введите количество рубинов для распределения",
    "appropriateG": "Распределить золото",
    "appropriateR": "Распределить рубины",
    "send": "Отправитель",
    "rec": "Получатель",
    "time": "Время",
    "more": "Больше",
    "noNation": "Вы можете пополнять баланс только пользователей в вашей стране. Если пользователь находится в другой стране, пожалуйста, свяжитесь с администратором",
    "opSuc": "Операция успешно выполнена",
    "noSearch": "Пользователь не найден",
    "isSend": (txt) => {
      return `Вы уверены, что хотите подарить этому пользователю ${txt} золотых монет?`
    },
    "yes": "подтвердить",
    "no": "отменить",
    "noUid": "UID не может быть пустым!!"
},
  fa:{
    "gold": "طلا",
    "ruby": "یاقوت",
    "gRc": "سوابق طلا",
    "rRc": "سوابق یاقوت",
    "enterId": "لطفاً شناسه کاربر را برای توزیع وارد کنید",
    "useG": "تعداد طلای موجود",
    "useR": "تعداد یاقوت‌های موجود",
    "enterG": "لطفاً مقدار طلای مورد نظر برای توزیع را وارد کنید",
    "enterR": "لطفاً تعداد یاقوت‌هایی که می‌خواهید توزیع کنید را وارد کنید",
    "appropriateG": "توزیع طلا",
    "appropriateR": "توزیع یاقوت",
    "send": "فرستنده",
    "rec": "گیرنده",
    "time": "زمان",
    "more": "بیشتر",
    "noNation": "شما فقط می‌توانید کاربران کشور خود را شارژ کنید. اگر کاربر در کشور شما نیست، لطفاً با مدیر تماس بگیرید",
    "opSuc": "عملیات با موفقیت انجام شد",
    "noSearch": "کاربر یافت نشد",
    "isSend": (txt) => {
      return `آیا مطمئن هستید که می‌خواهید ${txt} سکه طلا را به این کاربر هدیه دهید؟`
    },
    "yes": "تأیید",
    "no": "لغو",
    "noUid": "شناسه کاربری نمی‌تواند خالی باشد!!"
}



}



// WEBPACK FOOTER //
// src/pages/activity/labor/lang.js